module.exports = __webpack_public_path__ + "img/icon-logged_in_since.9d3001ed.svg";